export default __webpack_public_path__ + "static/media/pizzamarg.c5e3eed6.jpeg";